<template>

  <div id="page-user-list">

    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Country</label>
          <v-select :options="countryOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="countryFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Age</label>
          <v-select :options="ageOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="ageFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select :options="statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 sm:mb-0" />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow test">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-2 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0 mr-2" @click="exportData"><feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" /> Export as CSV</vs-button>
          <vs-button class="mb-4 md:mb-0 mr-2" @click="importData"><feather-icon icon="ArchiveIcon"  svgClasses="h-4 w-4" class="mr-2" /> Import CSV</vs-button> -->
          
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import handlingError from '@/handlingError/handlingError.js';
// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRenderSelfies from './cell-renderer/CellRenderSelfies.vue'
import CellRendererCountry from './cell-renderer/CellRendererCountry.vue'
import CellRendererAge from './cell-renderer/CellRendererAge.vue'

export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRenderSelfies,
    CellRendererCountry,
    CellRendererAge
  },
  data () {
    return {
      // Filter Options
      countryFilter: { label: 'All', value: 'all' },
      countryOptions: [
        { label: 'All', value: 'all' },
        { label: 'The Netherlands', value: 1 },
        { label: 'The United States', value: 2 },
        { label: 'The Ukriane', value: 3 },
      ],
      ageFilter: { label: 'All', value1: 0, value2:100 },
      ageOptions: [
        { label: 'All', value1: 0, value2:100 },
        { label: '~14', value1: 0, value2:14 },
        { label: '15~19', value1: 15, value2:19 },
        { label: '20~24', value1: 20, value2:24 },
        { label: '25~29', value1: 25, value2:29 },
        { label: '30~34', value1: 30, value2:34 },
        { label: '35~', value1: 35, value2:100 },
      ],
      statusFilter: { label: 'All', value: 'all' },
      statusOptions: [
        { label: 'All', value: 'all' },
        { label: 'Pending', value: false },
        { label: 'Approved', value: true },
      ],
      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          editable: true,
          width: 155,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'Full Name',
          field: 'firstname',
          width: 200,
          cellRendererFramework: 'CellRendererLink',
        },
        {
          headerName: 'Email',
          field: 'email',
          width: 300,
        },
        {
          headerName: 'Age',
          field: 'age',
          cellRendererFramework: 'CellRendererAge'
        },
        {
          headerName: 'Country',
          field: 'country',
          cellRendererFramework: 'CellRendererCountry'
        },
        {
          headerName: 'Selfies',
          field: 'selfies',
          cellRendererFramework: 'CellRenderSelfies'
        },
        {
          headerName: 'Status',
          field: 'accountStatus',
          cellRendererFramework: 'CellRendererStatus',
          width: 150
        },
        {
          headerName: 'Actions',
          field: 'accountStatus',
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        CellRenderSelfies,
        CellRendererCountry,
        CellRendererAge
      }
    }
  },
  watch: {
    organFilter (obj) {
      this.setColumnFilter('organization', obj.value)
    },
    departFilter (obj) {
      this.setColumnFilter('department', obj.value)
    },
    teamFilter (obj) {
      this.setColumnFilter('team', obj.value)
    },
    universtyFilter (obj) {
      this.setColumnFilter('universty', obj.value)
    },
    statusFilter (obj) {
      const val = obj.value === 'all' ? 'all' : obj.value === 'approved' ? 'true' : 'false'
      this.setColumnFilter('status', val)
    },
    roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    }
  },
  computed: {
    usersData () {
      const data = this.$store.state.userManagement.users
      let filtereddata = []
      for(var i = 0; i<data.length ; i++){
        const date = new Date;
        var ag=true, co=true;
        if(data[i].birthday)
        {
          var age = (date.getFullYear()-Number(data[i].birthday.split('-')[0]))
          ag = (age >= this.ageFilter.value1 && age <= this.ageFilter.value2) ? true : false;
        }
        else if(this.ageFilter.value1 != 0 || this.ageFilter.value2 != 100) ag=false
        if(data[i].country)
          co = (this.countryFilter.value != "all" && this.countryFilter.value != data[i].country) ? false : true;
        else if(this.countryFilter.value != "all") co=false
        var st = (this.statusFilter.value != "all" && this.statusFilter.value != data[i].accountStatus) ? false : true
        if(ag && co && st)
        filtereddata.push(data[i])
      }
      return filtereddata
      // return this.$store.state.userManagement.users
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    importData() {
      this.$router.push('/engineer/import')
    },
    exportData() {
      this.$router.push('/engineer/export')
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.organFilter = this.departFilter = this.teamFilter = this.universtyFilter = this.statusFilter = this.roleFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$store.dispatch('userManagement/fetchUsers')
      .catch(err => { 
        handlingError.handleError(err);
      })
  },
  beforeCreate() {
    if (!this.$store.state.auth.isUserLoggedIn()) this.$router.push('/login');
    //  User Reward Card
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>

